import {Component, Vue} from "vue-property-decorator";

interface Interface {
  parsePrice: Function;
}
@Component
export default class PriceHelper extends Vue {
  public parsePrice(price: number): string {
    if(!price){
      return '';
    }
    return price.toLocaleString(this.locale ?? 'nl-NL',{minimumFractionDigits: 2});
  }
  public parsePriceSplitDecimals(price: number): string {
    if(!price){
      return '';
    }
    const locale = (this.locale ?? 'nl-NL').replace('_', '-');
    let priceString = this.parsePrice(price);

    if (locale === 'nl-NL') {
      priceString = priceString.replace(',00', ',-');
    }
    return priceString.replace(/(\d+),(\d+)/, '$1,<span class="--decimal">$2</span>');
  }
  private get locale(): string {
    return this.$config.get('locale');
  }
}
